<template>
  <div class="container mx-auto h-full py-5">
    <el-dialog
      title="Editar registro de horas extra"
      :visible.sync="showAddOvertime"
      width="1100px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addOvertimeForm"
        status-icon
        ref="addOvertimeForm"
        @submit.native.prevent="
          saveOvertime('addOvertimeForm', addOvertimeForm)
        "
      >
        <el-row :gutter="15">
          <el-col :span="11">
            <el-form-item :prop="addOvertimeForm.employee">
              <el-select
                v-model="addOvertimeForm.employee"
                placeholder="Código o nombre de empleado"
                size="small"
                filterable
                clearable
                class="w-full"
                disabled
                @change="setStorage(addOvertimeForm)"
              >
                <el-option
                  v-for="e in employees"
                  :key="e.id"
                  :label="e.fullName"
                  :value="e.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row
              :gutter="15"
              v-for="(item, i) in addOvertimeForm.items"
              :key="i"
            >
              <el-col :span="11">
                <el-row :gutter="15">
                  <el-col :span="9">
                    <el-form-item
                      :prop="`items.${i}.type`"
                      :rules="rules.required"
                    >
                      <el-select
                        v-model="item.type"
                        placeholder="Seleccionar tipo"
                        size="mini"
                        filterable
                        clearable
                        class="w-full"
                        @change="setStorage(addOvertimeForm)"
                      >
                        <el-option
                          v-for="(type, i) of overtimeTypes"
                          :key="i"
                          :label="type.name"
                          :value="type.id"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :prop="`items.${i}.date`"
                      :rules="rules.validateDateRequired"
                    >
                      <el-input
                        size="mini"
                        v-model="item.date"
                        placeholder="DD/MM/YYYY"
                        autocomplete="off"
                        clearable
                        prefix-icon="el-icon-date"
                        v-mask="'##/##/####'"
                        @change="setStorage(addOvertimeForm)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item
                      :prop="`items.${i}.hours`"
                      :rules="rules.required"
                    >
                      <el-input-number
                        size="mini"
                        v-model="item.hours"
                        autocomplete="off"
                        clearable
                        type="number"
                        class="w-full"
                        :min="0"
                        :step="0.25"
                        @change="setStorage(addOvertimeForm)"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="10">
                <el-form-item>
                  <el-input
                    size="mini"
                    placeholder="Comentarios"
                    v-model="item.comment"
                    autocomplete="off"
                    clearable
                    @change="setStorage(addOvertimeForm)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <div class="flex">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    class="w-full"
                    style="margin-top: 5px"
                    v-if="addOvertimeForm.items.length > 1"
                    @click="removeTime(i)"
                  />
                  <el-button
                    type="success"
                    icon="el-icon-plus"
                    size="mini"
                    class="w-full"
                    style="margin-top: 5px"
                    @click="addNewTime(addOvertimeForm.items)"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <!-- <el-button size="small" @click="handleClose"
            >Cancelar</el-button
          > -->
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Asignar horas extra"
      :visible.sync="showAssignOvertime"
      width="1100px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="assignOvertimeForm"
        status-icon
        ref="assignOvertimeForm"
        @submit.native.prevent="
          saveOvertime('assignOvertimeForm', assignOvertimeForm, 'full')
        "
      >
        <el-row
          :gutter="15"
          class="border-b mb-2"
          v-for="(employee, e) of assignOvertimeForm.employees"
          :key="e"
        >
          <el-col :span="24">
            <el-row :gutter="15">
              <el-col :span="11">
                <el-form-item
                  :prop="`employees.${e}.employee`"
                  :rules="[
                    {
                      required: true,
                      message: 'Campo requerido',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-select
                    v-model="employee.employee"
                    placeholder="Código o nombre de empleado"
                    size="small"
                    filterable
                    clearable
                    class="w-full"
                    @change="
                      populateDetails(employee.employee, e),
                        setStorage(assignOvertimeForm)
                    "
                  >
                    <el-option
                      v-for="e in employees"
                      :key="e.id"
                      :label="e.fullName"
                      :value="e.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="small"
                  class="w-full"
                  style="margin-top: 5px"
                  v-if="assignOvertimeForm.employees.length > 1"
                  @click="removeEmployeeRegister(e)"
                />
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24">
                <el-row
                  :gutter="15"
                  v-for="(item, i) in employee.items"
                  :key="i"
                >
                  <el-col :span="11">
                    <el-row :gutter="15">
                      <el-col :span="9">
                        <el-form-item
                          :prop="`employees.${e}.items.${i}.type`"
                          :rules="rules.required"
                        >
                          <el-select
                            v-model="item.type"
                            placeholder="Seleccionar tipo"
                            size="mini"
                            filterable
                            clearable
                            class="w-full"
                            @change="setStorage(assignOvertimeForm)"
                          >
                            <el-option
                              v-for="(type, i) of overtimeTypes"
                              :key="i"
                              :label="type.name"
                              :value="type.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          :prop="`employees.${e}.items.${i}.date`"
                          :rules="rules.validateDateRequired"
                        >
                          <el-input
                            size="mini"
                            v-model="item.date"
                            placeholder="DD/MM/YYYY"
                            autocomplete="off"
                            clearable
                            prefix-icon="el-icon-date"
                            v-mask="'##/##/####'"
                            @change="setStorage(assignOvertimeForm)"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item
                          :prop="`employees.${e}.items.${i}.hours`"
                          :rules="rules.required"
                        >
                          <el-input-number
                            size="mini"
                            v-model="item.hours"
                            autocomplete="off"
                            clearable
                            type="number"
                            class="w-full"
                            :min="0"
                            :step="0.25"
                            @change="setStorage(assignOvertimeForm)"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item>
                      <el-input
                        size="mini"
                        placeholder="Comentarios"
                        v-model="item.comment"
                        autocomplete="off"
                        clearable
                        @change="setStorage(assignOvertimeForm)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <div class="flex">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="mini"
                        class="w-full"
                        style="margin-top: 5px"
                        v-if="employee.items.length > 1"
                        @click="removeEmployeeTime(e, i)"
                      />
                      <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="mini"
                        class="w-full"
                        style="margin-top: 5px"
                        @click="addEmployeeNewTime(e)"
                      />
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="15">
          <el-col :span="24">
            <el-button
              type="success"
              size="mini"
              @click="addNewEmployeeRegister()"
            >
              Otro empleado
            </el-button>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <!-- <el-button size="small" @click="showAssignOvertime = false"
            >Cancelar</el-button
          > -->
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24">
            <h3 class="text-l font-semibold">ASIGNACIÓN DE HORAS EXTRA</h3>
          </el-col>
        </el-row>

        <el-row :gutter="15" class="my-3">
          <el-col :span="24">
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${paysheet.code}) se ha abierto de manera extemporanéa.`"
              type="info"
              show-icon
              v-if="paysheet.override"
            />
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${
                paysheet.code
              }) estará disponible hasta el ${
                paysheet.sequence == 1 ? paysheet.limitQ1 : paysheet.limitQ2
              }/${
                new Date().getMonth() + 1
              }/${new Date().getFullYear()} 23:59:59`"
              type="info"
              show-icon
              v-else-if="!paysheetChangeDisabled"
            />
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${
                paysheet.code
              }) ha sido cerrado automaticamente por el sistema el ${
                paysheet.sequence == 1 ? paysheet.limitQ1 : paysheet.limitQ2
              }/${
                new Date().getMonth() + 1
              }/${new Date().getFullYear()} 23:59:59`"
              type="warning"
              show-icon
              v-else-if="!overtimeStatus"
            />
            <el-alert
              :closable="false"
              :title="`El periodo disponible para asignacion de horas extra para esta planilla (${paysheet.code}) ha sido cerrado por usted el ${overtimeStatus.closeTimestamp}`"
              type="warning"
              show-icon
              v-else
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="success"
              size="small"
              icon="el-icon-plus"
              @click="openAssignOvertime()"
              :disabled="paysheetChangeDisabled"
            >
              Asignar
            </el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-check"
              :disabled="
                paysheetChangeDisabled ||
                (overtimeStatus
                  ? Object.keys(overtimeStatus).length > 0
                  : overtimeStatus)
              "
              @click="closeOvertime(paysheet.id)"
            >
              Cerrar proceso
            </el-button>
            <el-button
              type="default"
              size="small"
              icon="el-icon-printer"
              @click="printReport(table.data)"
              >Imprimir</el-button
            >
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>
        <div class="flex flex-row space-x-8 text-base">
          <div class="flex flex-row space-x-2 border-b">
            <span class="font-semibold uppercase">total horas:</span>
            <span>{{ totalHoras }}</span>
          </div>
          <div class="flex flex-row space-x-2 border-b">
            <span class="font-semibold uppercase">total :</span>
            <span>{{ totalAmount | formatMoney }}</span>
          </div>
        </div>
        <div class="flex flex-col mt-4">
          <div
            class="
              flex flex-row
              border-b
              pb-1
              text-xs
              font-semibold
              text-gray-600
            "
          >
            <span
              v-for="(h, k) in table.headers"
              :key="k"
              class="flex flex-row px-1"
              :class="h.classes"
              :style="{ width: `${table.widths[k]}px` }"
              >{{ h.title }}</span
            >
          </div>
          <div
            class="h-16 flex flex-row justify-center items-center border-b"
            v-if="filteredOvertimes.length == 0"
          >
            <span class="text-xs text-gray-400">Sin Datos</span>
          </div>
          <ul class="flex flex-col text-xs" v-else>
            <li
              v-for="(v, j) in filteredOvertimes"
              class="flex flex-col hover:bg-gray-50 border-b"
              :class="{ 'bg-gray-100': j % 2 != 0 }"
              :key="j"
            >
              <div class="flex flex-row w-full">
                <div
                  @click="v.extended = !v.extended"
                  class="flex flex-row items-center h-8 px-1 cursor-pointer"
                  :class="table.headers[0].classes"
                  :style="{ width: `${table.widths[0]}px` }"
                >
                  <svg
                    v-if="v.extended"
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                  <svg
                    v-else
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
                <div
                  class="flex flex-row w-full cursor-pointer"
                  @click="openAddOvertime(v)"
                >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[1].classes"
                    :style="{ width: `${table.widths[1]}px` }"
                    >{{ j + 1 }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[2].classes"
                    :style="{ width: `${table.widths[2]}px` }"
                    >{{ `${v.code} - ${v.fullName}` }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[3].classes"
                    :style="{ width: `${table.widths[3]}px` }"
                    >{{ v.paysheet.startDate | formatDate }} -
                    {{ v.paysheet.endDate | formatDate }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[4].classes"
                    :style="{ width: `${table.widths[4]}px` }"
                    >{{ v.paysheet.code }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[5].classes"
                    :style="{ width: `${table.widths[5]}px` }"
                    >{{ v.totalHours }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[6].classes"
                    :style="{ width: `${table.widths[6]}px` }"
                    >{{ v.totalAmount | formatMoney }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[7].classes"
                    :style="{ width: `${table.widths[7]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[8].classes"
                    :style="{ width: `${table.widths[8]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[9].classes"
                    :style="{ width: `${table.widths[9]}px` }"
                  ></span>
                </div>
              </div>
              <ul class="flex flex-col w-full" v-if="v.extended">
                <li
                  class="flex flex-row w-full"
                  v-for="(o, i) of v.overtimes"
                  :key="i"
                >
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[0].classes"
                    :style="{ width: `${table.widths[0]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[1].classes"
                    :style="{ width: `${table.widths[1]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[2].classes"
                    :style="{ width: `${table.widths[2]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[3].classes"
                    :style="{ width: `${table.widths[3]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1"
                    :class="table.headers[4].classes"
                    :style="{ width: `${table.widths[4]}px` }"
                  ></span>
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[5].classes"
                    :style="{ width: `${table.widths[5]}px` }"
                    >{{ o.hours }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[6].classes"
                    :style="{ width: `${table.widths[6]}px` }"
                    >{{
                      (o.hours *
                        (v.currentSalary / (30 * 8)) *
                        o.overtimeType.factor)
                        | formatMoney
                    }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[7].classes"
                    :style="{ width: `${table.widths[7]}px` }"
                    >{{ o.overtimeType.name }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[8].classes"
                    :style="{ width: `${table.widths[8]}px` }"
                    >{{ o.date | formatDate }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[9].classes"
                    :style="{ width: `${table.widths[9]}px` }"
                    >{{ o.comment }}</span
                  >
                  <span
                    class="flex flex-row items-center h-8 px-1 border-t"
                    :class="table.headers[10].classes"
                    :style="{ width: `${table.widths[10]}px` }"
                  >
                    <button
                      v-if="!paysheetChangeDisabled"
                      class="hover:bg-red-500 p-1 rounded-full hover:text-white"
                      @click="deleteOvertime(o)"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg></button
                  ></span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="overtimes.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";
import { getHeader, getFooter, formatMoney } from "../../../utils";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const storagekey = "employee-overtime-employee";
export default {
  name: "EmployeesOvertime",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          overtimes {
            id
            employee { oldDepartment { name } id code name1 name2 lastname1 lastname2 currentSalary department { name parentDepartment { id name } } }
            hours
            overtimeType { name factor }
            date
            paysheet { id paysheetType { id } code startDate endDate }
            comment
            status
          }
          paysheets { id paysheetType { id name days } month year sequence active code startDate endDate limitQ1 limitQ2 override }
          overtimeTypes { id name factor }
          employees (where: { show: true }) {
            oldDepartment { name }
            id
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            paysheetType { id }
            code
            currentSalary
            terminated
            department {
              name
              parentDepartment { id name }
            }
            userActions { id }
            personalActions {
              startDate
              endDate
              value
              personalAction { baseSalary }
            }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => {
            vm.setData({
              overtimes: data.overtimes,
              paysheets: data.paysheets,
              overtimeTypes: data.overtimeTypes,
              employees: data.employees,
            });
          });
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    const validateDateRequired = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido"));
        return false;
      }

      const [d, m, y] = value.split("/");
      const date = new Date(`${m}/${d}/${y}`);
      const [miy, mim, mid] = this.paysheet.startDate.split("-");
      const [may, mam, mad] = this.paysheet.endDate.split("-");
      if (!dfn.isValid(date)) {
        callback(new Error("Formato fecha incorrecto."));
        return false;
      }
      if (
        dfn.isBefore(date, dfn.subDays(new Date(`${mim}/${mid}/${miy}`), 15)) ||
        dfn.isAfter(date, new Date(`${mam}/${mad}/${may}`))
      ) {
        callback(new Error("Fecha fuera de rango."));
        return false;
      }
      callback();
    };
    return {
      table: {
        widths: [
          "30",
          "30",
          "333",
          "160",
          "80",
          "65",
          "65",
          "125",
          "90",
          "260",
        ],
        headers: [
          {
            title: "",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
          {
            title: "Nombre completo",
            classes: [],
          },
          {
            title: "Periodo",
            classes: [],
          },
          {
            title: "Nómina",
            classes: [],
          },
          {
            title: "No. Horas",
            classes: ["justify-center"],
          },
          {
            title: "Total $",
            classes: ["justify-end"],
          },
          {
            title: "Unidad",
            classes: [],
          },
          {
            title: "Fecha",
            classes: [],
          },
          {
            title: "Observaciones",
            classes: [],
          },
          {
            title: "",
            classes: ["justify-end"],
          },
        ],
        data: [],
      },
      rawOvertimes: [],
      searchValue: "",
      page: {
        size: 15,
        number: 1,
      },
      showAddOvertime: false,
      addOvertimeForm: {
        employee: "",
        items: [
          {
            type: "",
            date: "",
            hours: "",
            comment: "",
          },
        ],
      },
      assignOvertimeForm: {
        employees: [
          {
            employee: "",
            items: [
              {
                type: "",
                date: "",
                hours: "",
                comment: "",
              },
            ],
          },
        ],
      },
      rules: {
        required: {
          required: true,
          message: "Campo requerido",
          trigger: "change",
        },
        validateDateRequired: [
          { validator: validateDateRequired, trigger: "blur" },
        ],
      },
      rawEmployees: [],
      paysheets: [],
      overtimeTypes: [],
      showAssignOvertime: false,
      paysheet: {},
      overtimeStatus: {},
    };
  },
  methods: {
    setStorage(form) {
      localStorage.setItem(storagekey, JSON.stringify(form));
    },
    setData({ overtimes, paysheets, overtimeTypes, employees }) {
      this.paysheet = paysheets.find((p) => p.active);
      axios
        .post("/", {
          query: `{
            overtimeStatus(where: { user: ${this.$store.getters.userID} paysheet: ${this.paysheet.id} }) { closedBySupervisor closedBySystem closeTimestamp }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.rawOvertimes = overtimes;
            this.paysheets = paysheets;
            this.overtimeTypes = overtimeTypes;
            this.rawEmployees = employees;
            this.overtimeStatus = data.overtimeStatus
              ? {
                  ...data.overtimeStatus,
                  closeTimestamp: dfn.format(
                    new Date(parseInt(data.overtimeStatus.closeTimestamp)),
                    "DD/MM/YYYY hh:mm:ss"
                  ),
                }
              : null;
          }
        });
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    addNewTime(items) {
      this.addOvertimeForm.items.push({
        extend: false,
        employee: "",
        type: "",
        date: items[items.length - 1].date,
        hours: "",
        comment: "",
      });
    },
    removeTime(index) {
      this.addOvertimeForm.items.splice(index, 1);
    },
    saveOvertime(formName, values, type) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas guardar estas horas extra?",
          "Confirmación",
          {
            confirmButtonText: "Si, guardar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";

                let data = "";
                const paysheet = this.paysheets.find((p) => p.active);

                if (type == "full") {
                  for (const value of values.employees) {
                    const { employee, items } = value;
                    const employeeFound = this.employees.find(
                      (e) => e.id == employee
                    );

                    for (const item of items) {
                      const overtime = this.overtimeTypes.find(
                        (o) => o.id == item.type
                      );
                      const hourlySalary =
                        employeeFound.currentSalary / (30 * 8);
                      const date = item.date.split("/");
                      data += `{
                        employee: ${employee},
                        paysheetType: ${employeeFound.paysheetType.id},
                        overtimeType: ${item.type},
                        hours: ${item.hours},
                        date: "${date[2]}-${date[1]}-${date[0]}",
                        factor: ${overtime.factor},
                        hourlySalary: ${hourlySalary},
                        comment: "${item.comment}"
                      },`;
                    }
                  }
                } else {
                  const { employee, items } = values;
                  const employeeFound = this.employees.find(
                    (e) => e.id == employee
                  );

                  for (const item of items) {
                    const overtime = this.overtimeTypes.find(
                      (o) => o.id == item.type
                    );
                    const hourlySalary = employeeFound.currentSalary / (30 * 8);
                    const date = item.date.split("/");
                    data += `{
                    employee: ${employee},
                    paysheetType: ${employeeFound.paysheetType.id},
                    overtimeType: ${item.type},
                    hours: ${item.hours},
                    date: "${date[2]}-${date[1]}-${date[0]}",
                    factor: ${overtime.factor},
                    hourlySalary: ${hourlySalary},
                    comment: "${item.comment}"
                  },`;
                  }
                }
                axios
                  .post("/", {
                    query: `mutation {
                      overtimeCreate(
                        where: { paysheet: ${paysheet.id} }
                        data: [${data}]
                      ){
                        id
                        employee { oldDepartment { name } id code name1 name2 lastname1 lastname2 currentSalary department { name parentDepartment { id name } } }
                        hours
                        overtimeType { name factor }
                        date
                        paysheet { id paysheetType { id } code startDate endDate }
                        comment
                        status
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawOvertimes = data.overtimeCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se han registrado las horas extras correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, guardar";
                    this.showAddOvertime = false;
                    this.showAssignOvertime = false;
                    localStorage.removeItem(storagekey);
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    printReport(values) {
      const data = [];
      let totalHours = 0;
      let totalMoney = 0;
      for (const employee of values.filter((v) => v.overtimes.length > 0)) {
        const hours = employee.overtimes.reduce((a, b) => a + b.hours, 0);
        const cost = employee.overtimes.reduce(
          (a, b) =>
            a +
            parseFloat(
              (
                b.hours *
                (employee.currentSalary  * 12 / 365 / 8) *
                b.overtimeType.factor
              ).toFixed(2)
            ),
          0
        );
        data.push([
          {
            border: [false, true, false, false],
            text: employee.code,
            bold: true,
          },
          {
            border: [false, true, false, false],
            text: `${employee.fullName}`,
            bold: true,
          },
          {
            border: [false, true, false, false],
            text: employee.oldDepartment ? employee.oldDepartment.name : "",
            fontSize: 8.5,
          },
          { border: [false, true, false, false], text: "", bold: true },
          { border: [false, true, false, false], text: "", bold: true },
          {
            border: [false, true, false, false],
            text: hours,
            alignment: "center",
            bold: true,
          },
          {
            border: [false, true, false, false],
            text: formatMoney(cost),
            alignment: "right",
            bold: true,
          },
        ]);

        totalHours += hours;
        totalMoney += cost;

        for (const overtime of employee.overtimes) {
          const [year, month, day] = overtime.date.split("-");
          data.push([
            "",
            {
              text: overtime.comment,
              colSpan: 2,
              style: { italics: true, fontSize: 8 },
            },
            "",
            {
              text: `(${overtime.overtimeType.factor.roundDecimal()}) ${
                overtime.overtimeType.name
              }`,
              fontSize: 8,
            },
            {
              text: dfn.format(
                new Date(`${month}/${day}/${year}`),
                "DD/MM/YYYY"
              ),
              fontSize: 8,
            },
            { text: overtime.hours, alignment: "center", fontSize: 8 },
            {
              text: formatMoney(
                overtime.hours *
                  (employee.currentSalary  * 12 / 365 / 8) *
                  overtime.overtimeType.factor
              ),
              alignment: "right",
              fontSize: 8,
            },
          ]);
        }
      }
      data.push(
        ...[
          ["", "", "", "", "", "", ""],
          [
            "",
            "",
            "",
            "",
            {
              text: "TOTALES",
              fontSize: 10,
              bold: true,
              alignment: "right",
              border: [false, true, false, true],
            },
            {
              text: totalHours,
              fontSize: 10,
              bold: true,
              alignment: "center",
              border: [false, true, false, true],
            },
            {
              text: formatMoney(totalMoney),
              fontSize: 10,
              bold: true,
              alignment: "right",
              border: [false, true, false, true],
            },
          ],
        ]
      );

      const [syear, smonth, sday] = values[0].paysheet.startDate.split("-");
      const [eyear, emonth, eday] = values[0].paysheet.endDate.split("-");
      let periodoClosed = "PERIODO ";
      if (this.paysheet.override) {
        periodoClosed += `EXTEMPORANEO ${dfn.format(
          new Date(),
          "DD/MM/YYYY hh:mm:ss"
        )}`;
      } else if (!this.paysheetChangeDisabled) {
        periodoClosed += `ABIERTO ${dfn.format(
          new Date(),
          "DD/MM/YYYY hh:mm:ss"
        )}`;
      } else if (!this.overtimeStatus) {
        periodoClosed += `CERRADO EL ${
          this.paysheet.sequence == 1
            ? this.paysheet.limitQ1
            : this.paysheet.limitQ2
        }/${new Date().getMonth() + 1}/${new Date().getFullYear()} 23:59:59`;
      } else {
        periodoClosed += `CERRADO EL ${this.overtimeStatus.closeTimestamp}`;
      }
      const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [20, 80, 20, 40],
        header: getHeader(
          "CALDER, SOCIEDAD ANÓNIMA",
          [
            new Date(`${smonth}/${sday}/${syear}`),
            new Date(`${emonth}/${eday}/${eyear}`),
          ],
          "REPORTE DE HORAS EXTRA",
          "period",
          `USUARIO: ${this.$store.getters.shortName} | NOMINA: ${values[0].paysheet.code}`,
          periodoClosed
        ),
        footer: getFooter(),
        content: [
          {
            style: "tableStyle",
            layout: {
              defaultBorder: false,
            },
            table: {
              headerRows: 1,
              widths: [25, "*", 120, 100, 50, 50, 50],
              body: [
                [
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "COD.",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "NOMBRE/COMENTARIOS",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "DEPARTAMENTO",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "UNIDAD",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "FECHA",
                    bold: true,
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "NO. HORAS",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 9,
                    text: "TOTAL",
                    bold: true,
                    alignment: "right",
                  },
                ],
                ...data,
              ],
            },
          },
        ],
        styles: {
          tableStyle: {
            fontSize: 8.5,
          },
        },
      };
      this.generating = false;
      pdfMake.createPdf(docDefinition).open();
    },
    openAddOvertime({ id }) {
      if (this.paysheetChangeDisabled) return;
      if (this.$refs.addOvertimeForm) {
        this.$refs.addOvertimeForm.resetFields();
      }
      this.showAddOvertime = true;
      this.addOvertimeForm.employee = id;
      const overtimes = this.table.data.find((d) => d.id == id);
      const items = overtimes.overtimes.map((o) => {
        return {
          comment: o.comment,
          date: o.date.split("-").reverse().join("/"),
          hours: o.hours,
          type: this.overtimeTypes.find((ot) => ot.name == o.overtimeType.name)
            .id,
        };
      });
      this.addOvertimeForm.items =
        items.length > 0
          ? items
          : [
              {
                type: "",
                date:
                  items.length > 0
                    ? items[items.length - 1].date
                    : dfn.format(new Date(), "DD/MM/YYYY"),
                hours: "",
                comment: "",
              },
            ];
    },
    openAssignOvertime() {
      if (this.paysheetChangeDisabled) return;
      if (this.$refs.assignOvertimeForm) {
        this.$refs.assignOvertimeForm.resetFields();
      }
      this.assignOvertimeForm = {
        employees: [
          {
            employee: "",
            items: [
              {
                type: "",
                date: dfn.format(new Date(), "DD/MM/YYYY"),
                hours: "",
                comment: "",
              },
            ],
          },
        ],
      };
      this.showAssignOvertime = true;
    },
    deleteOvertime({ id }) {
      if (this.paysheetChangeDisabled) return;
      this.$confirm(
        "¿Estás seguro que deseas eliminar este registro de hora extra?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation {
                    overtimeDelete(where: {id: ${id}}){
                      id
                      employee { oldDepartment { name } id code name1 name2 lastname1 lastname2 currentSalary department { name parentDepartment { id name } } }
                      hours
                      overtimeType { name factor }
                      date
                      paysheet { id paysheetType { id } code startDate endDate }
                      comment
                      status
                    }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawOvertimes = data.overtimeDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el registro de hora extra correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    addNewEmployeeRegister() {
      const date =
        this.assignOvertimeForm.employees[0].items[0].date == ""
          ? dfn.format(new Date(), "DD/MM/YYYY")
          : this.assignOvertimeForm.employees[0].items[0].date;
      this.assignOvertimeForm.employees.push({
        employee: "",
        items: [
          {
            extend: false,
            employee: "",
            type: "",
            date,
            hours: "",
            comment: "",
          },
        ],
      });
    },
    removeEmployeeRegister(index) {
      this.assignOvertimeForm.employees.splice(index, 1);
    },
    addEmployeeNewTime(e) {
      const items = this.assignOvertimeForm.employees[e].items;
      this.assignOvertimeForm.employees[e].items.push({
        extend: false,
        employee: "",
        type: "",
        date: this.assignOvertimeForm.employees[e].items[items.length - 1].date,
        hours: "",
        comment: "",
      });
    },
    removeEmployeeTime(e, index) {
      this.assignOvertimeForm.employees[e].items.splice(index, 1);
    },
    populateDetails(e, i) {
      const found = this.overtimes.find((employee) => employee.id == e);
      if (found && found.overtimes.length > 0) {
        this.assignOvertimeForm.employees[i].items = found.overtimes.map(
          (o) => {
            return {
              comment: o.comment,
              date: o.date.split("-").reverse().join("/"),
              hours: o.hours,
              type: this.overtimeTypes.find(
                (ot) => ot.name == o.overtimeType.name
              ).id,
            };
          }
        );
      }
    },
    handleClose(done) {
      this.checkBeforeClose(done);
    },
    checkBeforeClose(done) {
      const dialog = this.showAddOvertime ? "add" : "assign";
      const stored = localStorage.getItem(storagekey);
      if (stored) {
        this.$confirm(
          "Existe informacion sin guardar. ¿Desea guardar antes de salir?",
          "Autoguardado",
          {
            confirmButtonText: "Si, guardar",
            cancelButtonText: "No, gracias",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }
        )
          .then(() => {
            switch (dialog) {
              case "assign":
                this.saveOvertime(
                  "assignOvertimeForm",
                  this.assignOvertimeForm,
                  "full"
                );
                break;
              case "add":
                this.saveOvertime("addOvertimeForm", this.addOvertimeForm);
                break;
            }
          })
          .catch((cancel) => {
            localStorage.removeItem(storagekey);
            done();
          });
      } else {
        done();
      }
    },
    closeOvertime(id) {
      this.$confirm(
        "¿Estás seguro que deseas cerrar el proceso de asignación de horas extra?",
        "Confirmación",
        {
          confirmButtonText: "Si, cerrar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation {
                    overtimeStatusClose(data: {paysheet: ${id}}){ closedBySupervisor closedBySystem closeTimestamp }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.overtimeStatus = {
                      ...data.overtimeStatusClose,
                      closeTimestamp: dfn.format(
                        new Date(
                          parseInt(data.overtimeStatusClose.closeTimestamp)
                        ),
                        "DD/MM/YYYY hh:mm:ss"
                      ),
                    };
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha cerrado correctamente el proceso de asignación de horas extra."
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, cerrar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
  },
  computed: {
    employees() {
      const paysheetTypes = this.paysheets.filter((p) => p.active);
      return this.rawEmployees
        .filter(
          (e) =>
            e.userActions != null &&
            e.userActions.id == this.$store.getters.userID &&
            !e.terminated
        )
        .filter((e) => {
          const paysheetTypesList = paysheetTypes.map((p) => p.paysheetType.id);
          return (
            paysheetTypesList.includes(e.paysheetType.id) &&
            e.department.parentDepartment != null
          );
        })
        .map((e) => {
          return {
            ...e,
            fullName: `${e.name1 ? `${e.name1.trim()} ` : ""}${
              e.name2 ? `${e.name2.trim()} ` : ""
            }${e.name3 ? `${e.name3.trim()} ` : ""}${
              e.lastname1 ? `${e.lastname1.trim()} ` : ""
            }${e.lastname2 ? `${e.lastname2.trim()} ` : ""}${
              e.lastname3 ? `${e.lastname3.trim()} ` : ""
            }`,
            paysheet: paysheetTypes.find(
              (p) => p.paysheetType.id == e.paysheetType.id
            ),
          };
        });
    },
    overtimes() {
      const overtimes = this.employees.map((e) => {
        const paysheet = this.paysheets.find((p) => p.active);
        const overtimes = this.rawOvertimes.filter(
          (o) => o.employee.id == e.id && o.paysheet.id == paysheet.id
        );
        const personalActions = e.personalActions
          .filter(
            (pa) => pa.personalAction.baseSalary && pa.endDate && pa.startDate
          )
          .filter((pa) => {
            const [psyear, psmonth, psday] = e.paysheet.startDate.split("/");
            const [peyear, pemonth, peday] = e.paysheet.endDate.split("/");
            const paysheetStartDate = new Date(`${psmonth}/${psday}/${psyear}`);
            const paysheetEndDate = new Date(`${pemonth}/${peday}/${peyear}`);
            const [pasyear, pasmonth, pasday] = pa.startDate.split("-");
            const [paeyear, paemonth, paeday] = pa.endDate.split("-");
            const startDate = new Date(`${pasmonth}/${pasday}/${pasyear}`);
            const endDate = new Date(`${paemonth}/${paeday}/${paeyear}`);

            return endDate >= paysheetStartDate && startDate <= paysheetEndDate;
          });

        const currentSalary =
          personalActions.length > 0
            ? personalActions[0].value
            : e.currentSalary;

        return {
          ...e,
          currentSalary,
          overtimes,
          extended: false,
          totalHours: overtimes.reduce((a, b) => a + b.hours, 0),
          totalAmount: overtimes.reduce(
            (a, b) =>
              a +
              parseFloat(
                (
                  b.hours *
                  (currentSalary  * 12 / 365 / 8) *
                  b.overtimeType.factor
                ).toFixed(2)
              ),
            0
          ),
        };
      });
      this.table.data = overtimes;
      return overtimes;
    },
    filteredOvertimes() {
      if (this.table.data.length == 0) {
        return [];
      } else {
        return this.table.data
          .sort((a, b) => {
            if (a.code > b.code) return 1;
            if (a.code < b.code) return -1;
            return 0;
          })
          .filter((e) => {
            return (
              e.fullName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              e.code.toLowerCase().includes(this.searchValue.toLowerCase())
            );
          })
          .slice(
            this.page.number * this.page.size - this.page.size,
            this.page.size * this.page.number
          );
      }
    },
    totalHoras() {
      return this.filteredOvertimes.reduce((a, b) => a + b.totalHours, 0);
    },
    totalAmount() {
      return this.filteredOvertimes.reduce((a, b) => a + b.totalAmount, 0);
    },
    paysheetChangeDisabled() {
      const { sequence, limitQ1, limitQ2, override } = this.paysheet;
      return override
        ? false
        : this.overtimeStatus
        ? true
        : parseInt(dfn.format(new Date(), "DD")) >
          (sequence == 1 ? limitQ1 : limitQ2);
    },
  },
};
</script>
